import { z } from 'zod';
import { concurrencySchema, idSchema } from './common.js';
export const createBoardSchema = z.object({
    title: z.string().min(1, 'Titel ist Pflicht').max(80),
    icon: z.string().max(8).optional(),
    memberIds: z.array(idSchema).max(50).optional(),
});
export const patchBoardSchema = concurrencySchema
    .extend({
    title: z.string().min(1).max(80).optional(),
    icon: z.string().max(8).nullable().optional(),
    memberIds: z.array(idSchema).max(50).optional(),
    archived: z.boolean().optional(),
})
    .refine((v) => Object.keys(v).some((k) => k !== 'updatedAt'), {
    message: 'Keine Aenderung angegeben',
});
/**
 * Eigene Reihenfolge der Board-Liste (SPEC-Ergaenzung). Die ganze Liste auf
 * einmal, keine Nachbar-Angabe wie beim Verschieben einer Karte — bei einer
 * Handvoll Boards ist das robuster.
 */
export const reorderBoardsSchema = z.object({
    boardIds: z.array(idSchema).min(1).max(200),
});
export const createColumnSchema = z.object({
    title: z.string().min(1, 'Titel ist Pflicht').max(60),
    wipLimit: z.number().int().min(1).max(999).nullable().optional(),
    isDoneColumn: z.boolean().optional(),
});
export const patchColumnSchema = concurrencySchema
    .extend({
    title: z.string().min(1).max(60).optional(),
    /** Neue Position. Der Client uebergibt die Nachbarn, nicht den Key selbst. */
    afterColumnId: idSchema.nullable().optional(),
    wipLimit: z.number().int().min(1).max(999).nullable().optional(),
    isDoneColumn: z.boolean().optional(),
})
    .refine((v) => Object.keys(v).some((k) => k !== 'updatedAt'), {
    message: 'Keine Aenderung angegeben',
});
//# sourceMappingURL=board.js.map